import { render } from "./AppInfoModal.vue?vue&type=template&id=11ab4f18"
import script from "./AppInfoModal.vue?vue&type=script&lang=js"
export * from "./AppInfoModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__